import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
  () => ({
    desktopModalPaper: {
      width: "100%",
      padding: ({ isDesktop }) =>
        isDesktop ? "20px !important" : "20px 18px !important",
      fontWeight: "400",
    },

    mobile_modal_paper: {
      padding: ({ isDesktop }) => (isDesktop ? "20px" : "0px"),
      fontWeight: "400",
    },
  }),
  { name: "CreatorTool" }
);

export default useStyles;
